"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginWeb3Api = void 0;
var core_js_1 = require("@web3api/core-js");
var MsgPack = __importStar(require("@msgpack/msgpack"));
var tracing_js_1 = require("@web3api/tracing-js");
function isValidEnv(env) {
    return typeof env === "object" && !Array.isArray(env) && env !== null;
}
var PluginWeb3Api = /** @class */ (function (_super) {
    __extends(PluginWeb3Api, _super);
    function PluginWeb3Api(_uri, _plugin, _clientEnv) {
        var _this = _super.call(this) || this;
        _this._uri = _uri;
        _this._plugin = _plugin;
        _this._clientEnv = _clientEnv;
        tracing_js_1.Tracer.startSpan("PluginWeb3Api: constructor");
        tracing_js_1.Tracer.setAttribute("input", {
            uri: _this._uri,
            plugin: _this._plugin,
            clientEnv: _this._clientEnv,
        });
        tracing_js_1.Tracer.endSpan();
        return _this;
    }
    PluginWeb3Api.prototype.getSchema = function (_client) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(this._plugin.manifest.schema)];
            });
        });
    };
    PluginWeb3Api.prototype.getManifest = function (_options, _client) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw Error("client.getManifest(...) is not implemented for Plugins.");
            });
        });
    };
    PluginWeb3Api.prototype.getFile = function (_options, _client) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw Error("client.getFile(...) is not implemented for Plugins.");
            });
        });
    };
    PluginWeb3Api.prototype.invoke = function (options, client) {
        return __awaiter(this, void 0, void 0, function () {
            var module_1, method, resultFilter, input, modules, pluginModule, env, jsInput, result, result, data, e_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        module_1 = options.module, method = options.method, resultFilter = options.resultFilter;
                        input = options.input || {};
                        modules = this._getInstance().getModules(client);
                        pluginModule = modules[module_1];
                        if (!pluginModule) {
                            throw new Error("PluginWeb3Api: module \"" + module_1 + "\" not found.");
                        }
                        if (!pluginModule[method]) {
                            throw new Error("PluginWeb3Api: method \"" + method + "\" not found.");
                        }
                        env = this._getModuleClientEnv(module_1);
                        if (!isValidEnv(env)) return [3 /*break*/, 3];
                        if (!pluginModule["sanitizeEnv"]) return [3 /*break*/, 2];
                        return [4 /*yield*/, core_js_1.executeMaybeAsyncFunction(pluginModule["sanitizeEnv"], env, client)];
                    case 1:
                        env = (_a.sent());
                        _a.label = 2;
                    case 2:
                        this._getInstance().loadEnv(env, module_1);
                        _a.label = 3;
                    case 3:
                        jsInput = void 0;
                        // If the input is a msgpack buffer, deserialize it
                        if (input instanceof ArrayBuffer) {
                            result = MsgPack.decode(input);
                            tracing_js_1.Tracer.addEvent("msgpack-decoded", result);
                            if (typeof result !== "object") {
                                throw new Error("PluginWeb3Api: decoded MsgPack input did not result in an object.\nResult: " + result);
                            }
                            jsInput = result;
                        }
                        else {
                            jsInput = input;
                        }
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, core_js_1.executeMaybeAsyncFunction(pluginModule[method], jsInput, client)];
                    case 5:
                        result = (_a.sent());
                        tracing_js_1.Tracer.addEvent("unfiltered-result", result);
                        if (result !== undefined) {
                            data = result;
                            if (process.env.TEST_PLUGIN) {
                                // try to encode the returned result,
                                // ensuring it's msgpack compliant
                                try {
                                    MsgPack.encode(data);
                                }
                                catch (e) {
                                    throw Error("TEST_PLUGIN msgpack encode failure." +
                                        ("uri: " + this._uri.uri + "\nmodule: " + module_1 + "\n") +
                                        ("method: " + method + "\n") +
                                        ("input: " + JSON.stringify(jsInput, null, 2) + "\n") +
                                        ("result: " + JSON.stringify(data, null, 2) + "\n") +
                                        ("exception: " + e));
                                }
                            }
                            if (resultFilter) {
                                data = core_js_1.filterResults(result, resultFilter);
                            }
                            tracing_js_1.Tracer.addEvent("Filtered result", data);
                            return [2 /*return*/, {
                                    data: data,
                                }];
                        }
                        else {
                            return [2 /*return*/, {}];
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        throw Error("PluginWeb3Api: invocation exception encountered.\n" +
                            ("uri: " + this._uri.uri + "\nmodule: " + module_1 + "\n") +
                            ("method: " + method + "\nresultFilter: " + resultFilter + "\n") +
                            ("input: " + JSON.stringify(jsInput, null, 2) + "\n") +
                            ("modules: " + JSON.stringify(modules, null, 2) + "\n") +
                            ("exception: " + e_1.message));
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                error: error_1,
                            }];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PluginWeb3Api.prototype._getInstance = function () {
        this._instance || (this._instance = this._plugin.factory());
        return this._instance;
    };
    PluginWeb3Api.prototype._getModuleClientEnv = function (module) {
        if (!this._clientEnv) {
            return {};
        }
        if (module === "query") {
            return __assign(__assign({}, this._clientEnv.common), this._clientEnv.query);
        }
        else {
            return __assign(__assign({}, this._clientEnv.common), this._clientEnv.mutation);
        }
    };
    __decorate([
        tracing_js_1.Tracer.traceMethod("PluginWeb3Api: invoke")
    ], PluginWeb3Api.prototype, "invoke", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("PluginWeb3Api: getModuleClientEnv")
    ], PluginWeb3Api.prototype, "_getModuleClientEnv", null);
    return PluginWeb3Api;
}(core_js_1.Api));
exports.PluginWeb3Api = PluginWeb3Api;
//# sourceMappingURL=PluginWeb3Api.js.map